const getCacheBuster = () => `?bncachebuster=${Date.now()}`;

export {
  getCacheBuster,
};
